import { signIn } from "next-auth/react";

import {
  FLOW_ID_COOKIE,
  FLOW_SOURCE_COOKIE,
  FLOW_STARTED_COOKIE,
  type SignInSource,
} from "@/lib/oauth-flow-cookies";

const isBrowser = (): boolean => typeof document !== "undefined";

const setCookie = (name: string, value: string, attributes: string): void => {
  if (!isBrowser()) {
    return;
  }
  document.cookie = `${name}=${value}; ${attributes}`;
};

const generateFlowId = (): string => {
  if (
    isBrowser() &&
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const stampFlowDiagnostics = (source: SignInSource): void => {
  // SameSite=None; Secure so the cookies survive the cross-site return from the
  // IdP (Google/Zapier -> mcp.zapier.com)
  const attributes = "path=/; samesite=none; secure";
  setCookie(FLOW_ID_COOKIE, generateFlowId(), attributes);
  setCookie(FLOW_STARTED_COOKIE, String(Date.now()), attributes);
  setCookie(FLOW_SOURCE_COOKIE, source, attributes);
};

export const initiateZapierSignIn = (
  source: SignInSource,
  options?: Parameters<typeof signIn>[1],
  authorizationParams?: Parameters<typeof signIn>[2],
): void => {
  stampFlowDiagnostics(source);
  void signIn("zapier", options, authorizationParams);
};
